import { Brand } from '../../brand/brand.model';
import { Channel } from '../../channel/channel.model';
import { Dealer } from '../../dealer/dealer.model';
import { User } from '../../user/user.model';

export class AssignmentRuleInput {
  assignmentRuleName: string;
  user?: User;
  leadType?: string;
  origin?: string;
  positiveRule: string;
  isActive: string;
  postalCode: string;
  postalCodeType: string;
  brand?: Brand;
  channel?: Channel;
  dealer?: Dealer;
}
